import { Box, Button, Card, Divider, Link, Stack, Typography } from '@mui/material';
import { useBreakpoints, VideoPreviewCard } from 'shared';
import tap2minePreview from 'shared/assets/images/preview/tap2pay.png';

const videoSrc = 'https://player.vimeo.com/video/1097925559';
const WP_LINK =
  'https://cratd2csmartchain.gitbook.io/cratd2c-blockchain-testnet-and-mainnet-transition/tap-2-mine-whitepaper';

export const Intro = () => {
  const { isDownSmLayout } = useBreakpoints();

  return (
    <Box component="section">
      <Typography
        className="no-resize accent"
        variant="h1"
        sx={{
          fontSize: { xs: 40, sm: 72 },
        }}
      >
        Tap-2-Mine Whitelisting Portal
      </Typography>
      <Typography
        className="no-resize"
        variant="h1"
        sx={{
          fontSize: { xs: 40, sm: 72 },
        }}
      >
        Be First. Be Early.{' '}
        <Typography component="span" noWrap fontFamily="PP Editoral" fontStyle="italic" variant="inherit">
          Be Rewarded.
        </Typography>
      </Typography>

      <Stack display={{ sm: 'none' }} direction={{ sm: 'row' }} mt={6.5} mb={6}>
        <Typography variant="body2" className="no-resize regular" mb={2}>
          Join the future of blockchain mining - before anyone else!{' '}
        </Typography>
        <Button
          component="a"
          href={WP_LINK}
          target="_blank"
          rel="noopener noreferrer"
          size="medium"
          sx={{ px: 5, width: 'fit-content' }}
        >
          Whitepaper
        </Button>
      </Stack>

      <Stack
        width="100%"
        direction={{ sm: 'row' }}
        gap={{ xs: 5, sm: 0 }}
        alignItems="center"
        mt={5}
        mb={{ xs: 9, sm: 10 }}
      >
        <Box
          component="section"
          position="relative"
          borderRadius={6}
          overflow="hidden"
          sx={{ aspectRatio: '16/9', alignItems: 'center', display: 'flex' }}
          width={{ sm: '50%', xs: '100%' }}
        >
          <VideoPreviewCard
            boxSxProps={{ height: 'auto' }}
            image={tap2minePreview}
            videoSrc={videoSrc}
            subtitle="Tap-2-Mine"
          />
        </Box>

        <Box maxWidth={{ sm: 486, xs: '100%' }} flex={1} ml={{ xs: 0, sm: 5 }}>
          <Typography variant="h4" className="no-resize medium" mb={3}>
            Step In Early - Unlock VIP Access to Next-Gen Crypto Mining!
          </Typography>
          <Typography variant="body2" className="no-resize regular secondary" mb={2}>
            Get exclusive early access to the world’s first Proof of Interaction mining protocol before the public
            launch. Unlock priority access, premium rewards, and a head start on your crypto mining journey.
          </Typography>

          <Typography
            variant="body2"
            className="no-resize regular secondary"
            mb={2}
            display={{ xs: 'none', sm: 'block' }}
          >
            Join the future of blockchain mining - before anyone else!{' '}
          </Typography>

          {!isDownSmLayout && (
            <Button component="a" href={WP_LINK} target="_blank" rel="noopener noreferrer" size="medium">
              Whitepaper
            </Button>
          )}
        </Box>
      </Stack>

      <Card className="blur" sx={{ p: { xs: 2.5, sm: 3.5 } }}>
        <Stack direction={{ sm: 'row' }} alignItems="center" gap={{ xs: 2, sm: 3 }}>
          <Stack alignItems="center" flex={1}>
            <Typography variant="h5" textAlign="center">
              Total Whitelist Licenses Available:
            </Typography>
            <Typography variant="h6" className="accent semi-bold">
              1,000{' '}
              <Typography component="span" className="secondary" noWrap>
                (capped)
              </Typography>
            </Typography>
          </Stack>
          {!isDownSmLayout ? (
            <Divider flexItem orientation="vertical" />
          ) : (
            <Divider
              orientation="horizontal"
              sx={{
                width: '30%',
              }}
            />
          )}
          <Stack alignItems="center" flex={1}>
            <Typography variant="h5">Rewards Drop:</Typography>
            <Typography variant="h6" textAlign="center" className="secondary medium">
              After the first 1,000 Whitelist acquisitions, yield drop by{' '}
              <Typography component="span" className="accent semi-bold" noWrap>
                55%
              </Typography>
            </Typography>
          </Stack>
        </Stack>
      </Card>
    </Box>
  );
};
